/**
 * StatCard Molecule
 *
 * Card de estatística para dashboard
 */
import React from 'react'
import { TrendingUp, TrendingDown, Minus } from 'lucide-react'
import { formatNumber, formatPercent } from '../../core/admin.utils'

export default function StatCard({
	title,
	value,
	change,
	changeLabel,
	icon: Icon,
	iconColor = 'primary',
	className = '',
}) {
	const iconColorClasses = {
		primary: 'bg-primary-100 text-primary-600',
		blue: 'bg-blue-100 text-blue-600',
		green: 'bg-green-100 text-green-600',
		purple: 'bg-purple-100 text-purple-600',
		yellow: 'bg-yellow-100 text-yellow-600',
		red: 'bg-red-100 text-red-600',
	}

	const getTrendIcon = () => {
		if (change > 0) return TrendingUp
		if (change < 0) return TrendingDown
		return Minus
	}

	const getTrendColor = () => {
		if (change > 0) return 'text-green-600'
		if (change < 0) return 'text-red-600'
		return 'text-text-body'
	}

	const TrendIcon = getTrendIcon()

	return (
		<div className={`bg-base-300 rounded-xl border border-base-200 p-6 ${className}`}>
			<div className="flex items-start justify-between">
				<div>
					<p className="text-sm font-medium text-text-body">{title}</p>
					<p className="text-3xl font-bold text-text mt-2">
						{typeof value === 'number' ? formatNumber(value) : value}
					</p>
					{(change !== undefined || changeLabel) && (
						<div className="flex items-center mt-2 gap-1">
							{change !== undefined && (
								<>
									<TrendIcon className={`w-4 h-4 ${getTrendColor()}`} />
									<span className={`text-sm font-medium ${getTrendColor()}`}>
										{formatPercent(Math.abs(change))}
									</span>
								</>
							)}
							{changeLabel && (
								<span className="text-sm text-text-body ml-1">
									{changeLabel}
								</span>
							)}
						</div>
					)}
				</div>
				{Icon && (
					<div className={`p-3 rounded-lg ${iconColorClasses[iconColor]}`}>
						<Icon className="w-6 h-6" />
					</div>
				)}
			</div>
		</div>
	)
}
